import { memo } from "react";
import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { cn } from "@/lib/utils";

export const OfflineIndicator = memo(() => {
  const { isOffline } = useNetworkStatus();

  if (!isOffline) return null;

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-50",
        "bg-destructive text-destructive-foreground",
        "px-4 py-2 text-center text-sm font-medium",
        "flex items-center justify-center gap-2",
        "animate-fade-in"
      )}
    >
      <WifiOff className="w-4 h-4" />
      <span>You're offline. Some features may not work.</span>
    </div>
  );
});

OfflineIndicator.displayName = "OfflineIndicator";
